"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ninFormatWithOptionalSpace = exports.ninFormatWithSpace = void 0;
exports.calculateNinYear = calculateNinYear;
exports.calculateNinControl1 = calculateNinControl1;
exports.calculateNinControl2 = calculateNinControl2;
exports.yearFrom = yearFrom;
exports.monthFrom = monthFrom;
exports.dayFrom = dayFrom;
exports.individsifreFrom = individsifreFrom;
exports.hasOddIndividsiffer3 = hasOddIndividsiffer3;
exports.ninFormatWithSpace = /^(\d{6})\s(\d{5})$/;
exports.ninFormatWithOptionalSpace = /^(\d{6})\s?(\d{5})$/;
function calculateNinYear(yy, individsifre) {
    const year = parseInt(yy, 10);
    if (individsifre >= 0 && individsifre <= 499) {
        return year + 1900;
    }
    else if (individsifre >= 500 &&
        individsifre <= 999 &&
        year >= 0 &&
        year <= 39) {
        return year + 2000;
    }
    else if (individsifre >= 900 &&
        individsifre <= 999 &&
        year >= 40 &&
        year <= 99) {
        return year + 1900;
    }
    else {
        return undefined;
    }
}
function calculateNinControl1(dd, mm, yy, individsifre) {
    const { d1, d2, m1, m2, y1, y2, individsiffer1, individsiffer2, individsiffer3, } = getAllPartsOfNin(dd, mm, yy, individsifre);
    const control1 = 11 -
        ((3 * d1 +
            7 * d2 +
            6 * m1 +
            m2 +
            8 * y1 +
            9 * y2 +
            4 * individsiffer1 +
            5 * individsiffer2 +
            2 * individsiffer3) %
            11);
    if (control1 === 11) {
        return 0;
    }
    if (control1 === 10) {
        return undefined;
    }
    return control1;
}
function calculateNinControl2(dd, mm, yy, individsifre, control1) {
    if (control1 === undefined) {
        return undefined;
    }
    const { d1, d2, m1, m2, y1, y2, individsiffer1, individsiffer2, individsiffer3, } = getAllPartsOfNin(dd, mm, yy, individsifre);
    const control2 = 11 -
        ((5 * d1 +
            4 * d2 +
            3 * m1 +
            2 * m2 +
            7 * y1 +
            6 * y2 +
            5 * individsiffer1 +
            4 * individsiffer2 +
            3 * individsiffer3 +
            2 * control1) %
            11);
    if (control2 === 11) {
        return 0;
    }
    if (control2 === 10) {
        return undefined;
    }
    return control2;
}
function getAllPartsOfNin(dd, mm, yy, individsifre) {
    return {
        d1: parseInt(dd.substring(0, 1)),
        d2: parseInt(dd.substring(1, 2)),
        individsiffer1: parseInt(individsifre.substring(0, 1)),
        individsiffer2: parseInt(individsifre.substring(1, 2)),
        individsiffer3: parseInt(individsifre.substring(2, 3)),
        m1: parseInt(mm.substring(0, 1)),
        m2: parseInt(mm.substring(1, 2)),
        y1: parseInt(yy.substring(0, 1)),
        y2: parseInt(yy.substring(1, 2)),
    };
}
function yearFrom(nin) {
    return nin.substring(4, 6);
}
function monthFrom(nin) {
    return nin.substring(2, 4);
}
function dayFrom(nin) {
    return nin.substring(0, 2);
}
function individsifreFrom(nin) {
    return nin.substring(6, 9);
}
function hasOddIndividsiffer3(nin) {
    return !!(parseInt(nin.substring(8, 9)) % 2);
}
//# sourceMappingURL=ninUtils.js.map